import { type FC, type PropsWithChildren } from 'react';

import { Stack, Typography } from '@mui/material';

export enum ErrorCodes {
  Generic = -1,
  NotFound = 404,
  Unauthorized = 403
}

const Errors = {
  [ErrorCodes.Generic]: {
    title: 'Something went wrong',
    description: 'Sorry, an error occurred. Refreshing the page might fix this.'
  },

  [ErrorCodes.NotFound]: {
    title: 'Not Found',
    description: 'The page you are looking for does not exist'
  },

  [ErrorCodes.Unauthorized]: {
    title: 'Access Denied',
    description: 'You are not authorized to access this resource'
  }
} as const;

interface ErrorProps {
  code?: ErrorCodes;

  title?: string;
  description?: string;
}

export const ErrorPage: FC<PropsWithChildren<ErrorProps>> = ({ code, title, description, children }) => {
  const content = (code !== undefined && Errors[code]) || Errors[ErrorCodes.Generic];

  const titleText = title ?? content.title;
  const descriptionText = description ?? content.description;

  return (
    <Stack alignItems='center' justifyContent='center' height={1} width={1} gap={2}>
      <Stack alignItems='center' gap={0.5}>
        <Typography variant='h4' color='text.primary'>
          {titleText}
        </Typography>
        <Typography color='text.secondary'>{descriptionText}</Typography>
      </Stack>

      {children}
    </Stack>
  );
};
